import { render } from "./BarcodeVerifyPage.vue?vue&type=template&id=0a1578e2"
import script from "./BarcodeVerifyPage.vue?vue&type=script&lang=js"
export * from "./BarcodeVerifyPage.vue?vue&type=script&lang=js"

import exportComponent from "D:\\workspace\\eduwind-front\\eduwind-front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__